'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React from 'react';

const ProviderProfilePicAndExplanatoryText = () => {
  return (
    <div className="cur-flex cur-items-center cur-my-8">
      <Image
        alt="Provider profile pic"
        className="cur-mr-4"
        height={75}
        src="https://images.ctfassets.net/mdcr7mahi0vp/5T6Lz7SigY2uUpPM2JBe6O/e8a2742d2c9c22ada53348b64e562058/medical_history_intro_provider_profile_pic.png"
        width={75}
      />
      <div className="cur-flex-1">
        <Typography
          className="cur-leading-6 cur-whitespace-pre-line"
          size="meta"
          weight="bold"
        >
          Jennifer Kolinski, NP-C
        </Typography>
        <Typography className="cur-leading-6 cur-whitespace-pre-line">
          Your provider needs to know some basics about your health. Your
          answers are private and always will be.
        </Typography>
      </div>
    </div>
  );
};

export default ProviderProfilePicAndExplanatoryText;
